import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { VizSubtype } from '@lib.core/view/view-key';
import { Store } from '@lib.core/store/store.service';

@Injectable({ providedIn: 'root' })
export class VizSubtypeStorageService {
  private readonly store = inject(Store);
  private readonly key = 'viz-subtype';

  setVizSubtype(vizSubtype: VizSubtype | null): void {
    this.store.setValue(this.key, vizSubtype);
  }

  getVizSubtype(): Observable<VizSubtype | null> {
    return this.store.getValue<VizSubtype | null>(this.key).pipe(
      map((vizSubtype: VizSubtype | null | undefined) => vizSubtype ?? null)
    );
  }
}
